// extracted by mini-css-extract-plugin
module.exports = {"tagItem":"blog-post-module--tagItem--1mK8r","date":"blog-post-module--date--3Uhz3 index-module--date--1dpbA","dateWrapper":"blog-post-module--dateWrapper--3xteD"};